module.exports = __webpack_public_path__ + "static/img/tx.37c3ea6b.jpg";